import type { Breadcrumb } from "components/library/Breadcrumbs";

export const BasePath = "/report";
export const Title = "Reports";
export const RootBreadcrumb: Breadcrumb = {
  href: BasePath,
  title: Title,
};
